import { useState, useEffect } from "react";
import { qs } from "url-parse";

export default function useSearch(initial, location, history) {
  const initialState = { ...initial, ...qs.parse(location.search) };

  const [state, setState] = useState(initialState);

  const setSearch = search => {
    setState(prev => ({ ...prev, ...search }));
  };

  useEffect(() => {
    const search = qs.stringify(state);
    history.push({ search });
  }, [state]);

  useEffect(() => {
    const un = history.listen(location => {
      if (qs.stringify(state) != qs.stringify(qs.parse(location.search))) {
        const search = qs.parse(location.search);
        setState({ ...initial, ...search });
      }
    });

    return un;
  }, [location, state]);

  return [state, setSearch];
}
